import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import '../404/Page404.scss';
import { AnimatedIcon } from '../../components/commons/AnimatedIcon';
import ErrorIconLight from '../../assets/images/lottieIcons/error/error.light.json';
import ErrorIconDark from '../../assets/images/lottieIcons/error/error.dark.json';
import { CustomMUIButton } from '../../components/commons/buttons/CustomMUIButton';
import { ButtonClassNames, GlobalRouteNames } from '../../models/Common';

export const TimeOutPage = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleButton = () => {
    history.push(GlobalRouteNames.HomePage);
  };

  return (
    <div className="page-404 page">
      <div className="page-404__container container">
        <AnimatedIcon lightIcon={ErrorIconLight} darkIcon={ErrorIconDark} className="page-404__icon-limit" />
        <div className="page-404__content">
          <h1>{t('multiAccount.errorOccurred')}</h1>
          <div className="page-404__content__text-btn-container">
            <p style={{ fontSize: '18px' }}>{t('multiAccount.linkExpired')}</p>
            <p style={{ marginTop: '-15px' }}>{t('multiAccount.requestJoinAgain')}</p>
            <CustomMUIButton
              label={t('buttons.toMain')}
              handleClick={handleButton}
              className={ButtonClassNames.PrimaryFulfilled}
              isBold
            />
          </div>
        </div>
      </div>
    </div>
  );
};
